module.exports = __webpack_public_path__ + "static/img/logo-light.51d2b894.svg";